import htmlEmailTemplateApi from "~/api/html_email_template";

const fetchHtmlEmailTemplates = ({ commit, state }) => {
  if (state.fetchingHtmlEmailTemplates === false && state.htmlEmailTemplates.length === 0) {
    commit("SET_FETCHING_HTML_EMAIL_TEMPLATES", true);

    htmlEmailTemplateApi
      .paginate(1, 200)
      .then((response) => {
        commit("SET_HTML_EMAIL_TEMPLATES", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_HTML_EMAIL_TEMPLATES", false);
      });
  }
};

const getHtmlEmailTemplateById = async (context, htmlEmailTemplateId) => {
  if (context.state.fetchingHtmlEmailTemplatesIds.indexOf(htmlEmailTemplateId) !== -1
    || context.getters.hasHtmlEmailTemplateById(htmlEmailTemplateId)) {
    return context.getters.getHtmlEmailTemplateById(htmlEmailTemplateId);
  }

  context.commit("SET_FETCHING_HTML_EMAIL_TEMPLATE_IDS", [htmlEmailTemplateId]);

  return htmlEmailTemplateApi
    .getHtmlEmailTemplateById(htmlEmailTemplateId)
    .then((response) => {
      context.commit("UNSET_FETCHING_HTML_EMAIL_TEMPLATE_IDS", [htmlEmailTemplateId]);
      context.commit("CACHE_HTML_EMAIL_TEMPLATE", response.data);

      return response.data;
    });
};

const setHtmlEmailTemplates = (context, htmlEmailTemplates) => {
  context.commit("SET_HTML_EMAIL_TEMPLATES", htmlEmailTemplates);
};

export default {
  fetchHtmlEmailTemplates,
  setHtmlEmailTemplates,
  getHtmlEmailTemplateById,
};
